var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{staticClass:"mt-4"},[_c('v-pagination',{attrs:{"length":10,"total-visible":6}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }